import moment from 'moment';

import { readArchive } from '../../../util/archive';
import { sequence } from '../../../util/promises';

import { DATE_FORMAT_OUTPUT, MESSAGES_BLOCK_COUNT, MESSAGE_ATTACHMENTS_SEPARATOR } from '../ConversationActions';
import { getLinksInMessage } from '../BookActions';

const SYSTEM_MESSAGES = [
    'Liked a message',
    '^Reacted (.)* to your message$',
];

// Read selected file by user
// For Messenger: User must select an archive
export function readFile(file, options, onProgress) {
    if(file.type.includes('json')) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                onProgress(100);
                console.log(reader.result);
                resolve([
                    {
                        path: file.name,
                        content: reader.result,
                    },
                ]);
            };
            reader.readAsText(file);
        });
    }
    return readArchive(file, options, onProgress);
}

export function getFiles(file, imagesPaths = [], onProgress = () => {}) {
    return new Promise((resolve, reject) => {
        // console.log('FB getImages', imagesPaths, imagesPaths.map(imagePath => getMediaFileName(imagePath)));
        // console.log('local images', imagesPaths.filter(imagePath => !/http(s)?:\/\//.test(imagePath)).map(imagePath => new RegExp(getMediaFileName(imagePath).split('.').shift(), 'gi')));
        // console.log('distant images', imagesPaths.filter(imagePath => /http(s)?:\/\//.test(imagePath)).map(imagePath => new RegExp(getMediaFileName(imagePath).split('.').shift(), 'gi')));
        const localFiles = imagesPaths.filter(imagePath => !/http(s)?:\/\//.test(imagePath));
        readArchive(
            file,
            { includeRegexFiles: [...localFiles.map(imagePath => new RegExp(getMediaFileName(imagePath).split('.').shift(), 'gi')), ...localFiles.map(imagePath => new RegExp(getMediaFileName(imagePath.replace('messages/', '')).split('.').shift(), 'gi'))] },
            onProgress,
        ).then(localImages => {
            // console.log('Local images done', localImages);

            return readArchive(
                file,
                { includeRegexFiles: imagesPaths.filter(imagePath => /http(s)?:\/\//.test(imagePath)).map(imagePath => new RegExp(getMediaFileName(imagePath).split('.').shift(), 'gi')) },
                onProgress,
            ).then(distantImages => {
                resolve([
                    ...(localImages || []),
                    ...(distantImages || []).map(distantImage => {
                        const ext = distantImage.filename.split('.').pop();
                        const filename = getMediaFileName(imagesPaths.find(imagePath => {
                            const imagePathParts = distantImage.filename.split('_');
                            imagePathParts.pop();
                            return imagePath.includes(imagePathParts.join('_'));
                        }) || '');
                        return {
                            ...distantImage,
                            filename,
                        };
                    }),
                ]);
            }).catch(reject);

            // const percentile = 100 / imagesPaths.length;
            // return sequence(imagesPaths, imagePath => {
            //     console.log('Fetch distant image', imagePath);
            //     return new Promise((resolveDistant, rejectDistant) => {
            //         setTimeout(() => {
            //             fetch(imagePath, {
            //                 method: 'GET',
            //             },
            //             {
            //                 'Access-Control-Allow-Origin': 'no-cors',
            //             })
            //             .then(response => {
            //                 response.blob().then(blob => {
            //                     onProgress(percentile);
            //                     resolveDistant({
            //                         filename: getMediaFileName(imagePath),
            //                         content: blob,
            //                         type: response.headers.get('content-type'),
            //                     });
            //                 });
            //             })
            //             .catch(err => {
            //                 onProgress(percentile);
            //                 console.error('getImages', imagePath, err);
            //                 resolveDistant(false);
            //             });
            //         }, 100);
            //     });
            // }).then(distantImages => {
            //     console.log('Distant images', distantImages);
            //     resolve([
            //         ...(localImages || []),
            //         ...(distantImages || []),
            //     ]);
            // }).catch(reject);
        }).catch(reject);
    });
}

export function canHandleImages(file) {
    return !['json'].some(type => file.type.includes(type));
}

// Retrieve profile name
export function getProfileName(entries = []) {
    let participants = [];
    entries.forEach(entry => {
        const json = JSON.parse(entry.content);
        (json.participants || []).forEach(participant => {
            let newParticipant = participants.find(existingParticipant => existingParticipant.name === participant.name);
            if(newParticipant) {
                newParticipant = {
                    ...newParticipant,
                    count: newParticipant.count + 1,
                };
            } else {
                newParticipant = {
                    ...participant,
                    count: 1,
                };
            }
            participants = participants.filter(existing => existing.name !== newParticipant.name);
            participants.push(newParticipant);
        });
    });
    return decodeURIComponent(escape(participants && participants.length ? participants.sort((a, b) => b.count - a.count).shift().name : ''));
}

// Retrieve threads names
export function getThreads(entries) {
    let threads = [];

    entries.forEach(entry => {
        const json = JSON.parse(entry.content);

        const name = decodeURIComponent(escape(json.title));
        const id = entry.path;

        let friendThread = threads.find(thread => thread.name === name);
        if(!friendThread) {
            friendThread = {
                name,
                id,
                providerId: json.thread_path.toLowerCase(),
                count: 0,
            };
        }

        friendThread.count += json.messages ? json.messages.length : 0;

        threads = threads.filter(thread => thread.name !== name);

        threads.push(friendThread);
    });

    return threads;
}

// Generate CSV Content
// Separate messages in distinct csv (10 000 messages / csv)
export function getArchiveContent(entries, from, thread, options = { withImages: false, withMedias: false }, onProgress = percentile => {}) {
    console.log(thread, from, options, entries);

    const participants = [];
    let messages = [];
    const messagesBlocks = [];
    let images = [];
    let medias = [];

    entries
    .filter(entry => {
        // console.log(entry.path);
        // console.log(`'messages/'' included? ${`${entry.path}`.toLowerCase().includes('messages/')}`);
        // console.log(`Thread providerId included? ${`${entry.path}`.toLowerCase().includes(thread.providerId.toLowerCase())}`);
        // `${entry.path}`.toLowerCase().includes('messages/') && !`${entry.path}`.toLowerCase().includes(thread.providerId.toLowerCase()) && console.error('Entry path does not include providerId', entry.path, thread.providerId);
        return !`${entry.path}`.toLowerCase().includes('messages/') || `${entry.path}`.toLowerCase().includes(thread.providerId.toLowerCase());
    })
    .forEach(entry => {
        onProgress(1); // Init progress

        // Need to escape unicode sequence before json parse
        const conversationData = JSON.parse(decodeURIComponent(escape(entry.content)));
        messages = messages.concat(conversationData.messages);
    });

    messages = messages
        .filter(message => !isSystemMessage(message))
        .sort((a, b) => a.timestamp_ms - b.timestamp_ms)
        .map(message => {
            return {
                ...message,
                ...getMessageContent(message, from, thread.name, options),
            };
        })
        .filter(messageData => {
            // !messageData.messageCsv && console.error('Message not valid', messageData);
            // messageData.messageImages.length && console.log(messageData.messageImages, entries, entries.some(entry => messageData.messageImages.some(imagePath => imagePath && `${entry.path}`.toLowerCase().includes(imagePath.toLowerCase()))));
            // @TODO: Check if image file is in entries (image entries)
            return messageData.messageCsv;
        });

    const iteration = Math.floor(messages.length / MESSAGES_BLOCK_COUNT);

    const percentile = 100 / (iteration + 1);

    console.log(`${messages.length} messages to check`);

    for(let i = 0; i <= iteration; i += 1) {
        console.log(`Messages block process: ${i + 1}/${iteration + 1}`);
        const messagesBlock = messages.splice(0, MESSAGES_BLOCK_COUNT);

        onProgress(percentile);

        let csv = '';
        messagesBlock.forEach(message => { // eslint-disable-line
            const { messageParticipant, messageCsv, messageImages, messageMedias } = message;
            if(!participants.includes(messageParticipant)) {
                participants.push(messageParticipant);
            }
            csv += messageCsv;
            images = images.concat(messageImages);
            medias = medias.concat(messageMedias);
        });

        if(messagesBlock[0]) {
            messagesBlocks.push({
                sort: i,
                filename: `messages_${i + 1}.csv`,
                content: csv,
                messages: messagesBlock,
                start: new Date(messagesBlock[0].timestamp_ms),
                end: new Date((messagesBlock[messagesBlock.length - 1] || messagesBlock[0]).timestamp_ms),
            });
        } else {
            console.error('Missing messages in block', messagesBlock, participants);
        }
    }

    return {
        participants,
        messagesBlocks,
        images,
        medias,
    };
}

function getMessageContent(message, from, to, options = { withImages: false, withMedias: false }) {
    let messageCsv = '';
    const medias = [...getMessageMedias(message, 'link')];

    const messageImages = getMessageMedias(message, 'image');
    const messageMedias = getMessageMedias(message, ['audio', 'video']);

    if(options.withImages) {
        medias.push(...messageImages);
    }
    if(options.withMedias) {
        medias.push(...messageMedias);
    }

    const senderName = decodeURIComponent(escape(message.sender_name));
    const date = moment(message.timestamp_ms, 'x').format(DATE_FORMAT_OUTPUT).split('+').shift();

    if(!isSystemMessage(message)) {
        if(message.content || medias.length) {
            messageCsv = `${date};`;
            messageCsv += `${senderName};`;
            messageCsv += `${senderName === from ? to : from};`;
            messageCsv += `${message.content ? encodeURIComponent(decodeURIComponent(escape(message.content))) : ''};`; // escape and decode unicode before encodeURIComponenent
            messageCsv += `${senderName === from ? 'true' : 'false'};`;
            messageCsv += (medias && medias.length ? medias.map(media => getMediaFileName(media)).join(MESSAGE_ATTACHMENTS_SEPARATOR) : '');
            messageCsv += '\n';
        } else if(message.share && (message.share.link || message.share.original_content_owner)) {
            messageCsv = `${date};`;
            messageCsv += `${senderName};`;
            messageCsv += `${senderName === from ? to : from};`;
            messageCsv += `${message.share.original_content_owner ? encodeURIComponent(decodeURIComponent(escape(message.share.original_content_owner))) : ''};`; // escape and decode unicode before encodeURIComponenent
            messageCsv += `${senderName === from ? 'true' : 'false'};`;
            messageCsv += `${message.share.link || ''}`;
            messageCsv += '\n';
        }
    }
    return { messageParticipant: senderName, messageCsv, messageImages, messageMedias };
}

function isSystemMessage(message) {
    return SYSTEM_MESSAGES.some(systemMessage => {
        const regex = new RegExp(systemMessage, 'g');
        return (message.content || '').trim().includes(systemMessage) || regex.test((message.content || '').trim());
    });
}

// Retrieve profile name
function getMessageMedias(message, types = null) {
    if(types && !Array.isArray(types)) {
        types = [types];
    }
    if(!types || !types.length) {
        types = null;
    }

    const medias = [];

	if(!types || types.includes('link')) {
		medias.push(...(getLinksInMessage(message.content) || []));
	}

    if(message.photos && message.photos.length && (!types || types.includes('image'))) {
        medias.push(...message.photos.filter(photoData => photoData.uri /* && !photoData.uri.includes('.gif') */).map(photoData => photoData.uri.toLowerCase()));
    }

    if(message.gifs && message.gifs.length && (!types || types.includes('video'))) {
        medias.push(...message.gifs.filter(gifData => gifData.uri).map(gifData => gifData.uri.toLowerCase()));
    }

    if(message.videos && message.videos.length) {
        const videoUris = !types || types.includes('video')
                ? message.videos.filter(videoData => videoData.uri).map(videoData => videoData.uri.toLowerCase())
                : [];

        const videoThumbnails = !types || types.includes('image')
                ? message.videos.filter(videoData => videoData.thumbnail && videoData.thumbnail.uri).map(videoData => videoData.thumbnail.uri.toLowerCase())
                : [];
        videoUris.length && medias.push(...videoUris);
        videoThumbnails.length && medias.push(...videoThumbnails);
    }

    if(message.audio_files && message.audio_files.length && (!types || types.includes('audio'))) {
        medias.push(...message.audio_files.filter(audioData => audioData.uri).map(audioData => audioData.uri.toLowerCase()));
    }

    if(message.sticker && (!types || types.includes('image'))) {
        medias.push(message.sticker.uri.toLowerCase());
    }

    // console.log('message medias', medias);
    return medias;
}

function getMediaFileName(path) {
    return path.split('?').shift().split('/').pop();
}
